import {http, param} from '../../utils/http'
import conf from '../../config'

export const API_ROOT = `${conf.API_URL}`

const dashboardService = {
    findRecallsCard(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'status', val: payload.status },
            { query: 'communicationType', val: payload.eventCategory },
            { query: 'supplier_names', val: payload.supplier_names },
        ]
        return http.get(`${API_ROOT}/provider/dashboard${param(arr)}`, { stopDefaultLoader: payload.stopDefaultLoader }).then(resp => {
            return resp
        })
    },
    findDashboardCount(communicationId, providerCommunicationId, recallSiteCount, stopDefaultLoader) {
        var arr = [
            { query: 'communicationId', val: communicationId },
            { query: 'providerCommunicationId', val: providerCommunicationId },
            { query: 'recallSiteCount', val: recallSiteCount },
        ]
        return http.get(`${API_ROOT}/provider/dashboard/dashboardCount${param(arr)}`, { stopDefaultLoader: stopDefaultLoader }).then(resp => {
            return resp
        })
    },
    findSupplierFilter(communicationType) {
        return http.get(`${API_ROOT}/provider/dashboard/${communicationType}`, { stopDefaultLoader: true }).then(resp => {
            return resp
        })
    },
    saveDontRemindMeAgain (dontRemindAgainValue) {
        return http.post(`${API_ROOT}/provider/dashboard/${dontRemindAgainValue}`).then(resp => {
            return resp
        })
    },
    getChildRecallDocuments(communicationId, providerCommunicationId) {
        return http.get(`${API_ROOT}/provider/dashboard/child-recall-documents/${communicationId}/${providerCommunicationId}`).then(resp => {
            return resp
        })
    },
}

export default dashboardService
